import { extend } from './extend.util';

/**
 * ç±»ä¼¼ `_.get`ï¼æ ¹æ® `path` è·åå®å¨å¼
 * jsperf: https://jsperf.com/es-deep-getttps://jsperf.com/es-deep-get
 *
 * @param obj æ°æ®æºï¼æ ææ¶ç´æ¥è¿å `defaultValue` å¼
 * @param path è¥ `null`ã`[]`ãæªå®ä¹åæªæ¾å°æ¶è¿å `defaultValue` å¼
 * @param defaultValue é»è®¤å¼
 */
export function deepGet(obj: any, path: string | string[], defaultValue?: any) {
  if (!obj || path == null || path.length === 0) { return defaultValue; }
  if (!Array.isArray(path)) {
    // tslint:disable-next-line:no-bitwise
    path = ~path.indexOf('.') ? path.split('.') : [path];
  }
  if (path.length === 1) {
    const checkObj = obj[path[0]];
    return typeof checkObj === 'undefined' ? defaultValue : checkObj;
  }
  return path.reduce((o, k) => o[k], obj) || defaultValue;
}

export function deepCopy(obj: any) {
  const result = extend(true, {}, { _: obj });
  return result._;
}

/** å¤å¶åå®¹è³åªè´´æ¿ */
export function copy(value: string): Promise<string> {
  return new Promise<string>((resolve, reject): void => {
    let copyTextArea = null as HTMLTextAreaElement;
    try {
      copyTextArea = document.createElement('textarea');
      copyTextArea.style.height = '0px';
      copyTextArea.style.opacity = '0';
      copyTextArea.style.width = '0px';
      document.body.appendChild(copyTextArea);
      copyTextArea.value = value;
      copyTextArea.select();
      document.execCommand('copy');
      resolve(value);
    } finally {
      if (copyTextArea && copyTextArea.parentNode) {
        copyTextArea.parentNode.removeChild(copyTextArea);
      }
    }
  });
}

